
import { useState, useEffect } from "react";

export function useDebounce(callback: (...args: any[]) => void, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState<string>("");

  useEffect(() => {
    const handler = setTimeout(() => {
      callback(debouncedValue);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [debouncedValue, callback, delay]);

  return setDebouncedValue;
}
